var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.stripeVisible,
          expression: "stripeVisible"
        }
      ],
      class: _vm.containerClass,
      attrs: { transition: "fade" },
      on: {
        click: function($event) {
          return _vm.stripeClicked()
        }
      }
    },
    [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.body) } }),
      _vm._v(" "),
      _vm.caretIcon
        ? _c("div", { staticClass: "link-caret-icon" }, [
            _c("svg", [_c("use", { attrs: { "xlink:href": _vm.caretIcon } })])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }